module.exports = __webpack_public_path__ + "img/w矩形 87@3x.6ea0fa22.png";